module.exports = __webpack_public_path__ + "img/no_rule.23644660.png";